import styled from '@emotion/styled';

export const BlogPostsGrid = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 30px 20px;
  margin-top: 20px;
  ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 100%;
    grid-gap: 1rem;
    padding: 1rem;
  }
`;
